import type { OfStatusCategory } from '../../api/types';

/**
 * Présentation du statut d'un OF (couleur, icône, libellé) et barre d'avancement.
 * Partagé entre le détail de fournée et les cartes TV.
 */
const STATUS: Record<OfStatusCategory, { label: string; icon: string; dot: string; bar: string; text: string }> = {
  NON_DEMARRE: { label: 'Non démarré', icon: '○', dot: 'bg-gray-300', bar: 'bg-gray-300', text: 'text-gray-500' },
  EN_ATTENTE: { label: 'En attente', icon: '◔', dot: 'bg-amber-400', bar: 'bg-amber-400', text: 'text-amber-700' },
  EN_COURS: { label: 'En cours', icon: '⚙', dot: 'bg-blue-500', bar: 'bg-blue-500', text: 'text-blue-700' },
  TERMINE: { label: 'Terminé', icon: '✔', dot: 'bg-green-500', bar: 'bg-green-500', text: 'text-green-700' },
};

export function statusLabel(c: OfStatusCategory): string {
  return STATUS[c].label;
}
export function statusIcon(c: OfStatusCategory): string {
  return STATUS[c].icon;
}
export function statusDot(c: OfStatusCategory): string {
  return STATUS[c].dot;
}

/** Pastille + libellé de statut. */
export function StatusBadge({ category }: { category: OfStatusCategory }) {
  const s = STATUS[category];
  return (
    <span className={`inline-flex items-center gap-1 text-xs ${s.text}`}>
      <span>{s.icon}</span> {s.label}
    </span>
  );
}

/** Barre d'avancement colorée selon le statut. */
export function ProgressBar({ pct, category, height = 6 }: { pct: number; category?: OfStatusCategory; height?: number }) {
  const color = category ? STATUS[category].bar : pct >= 100 ? 'bg-green-500' : pct > 0 ? 'bg-blue-500' : 'bg-gray-300';
  return (
    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded overflow-hidden" style={{ height }}>
      <div className={`h-full ${color} transition-all`} style={{ width: `${Math.max(0, Math.min(100, pct))}%` }} />
    </div>
  );
}
